import * as React from 'react'

import { ChevronRightIcon } from 'lucide-react'
import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '~/client/src/shared/components/shadcn-ui/popover'

import PRE_POPULATED_COLORS from '../../utils/deliveryPrepopulatedColors'
import ColorPicker from './ColorPicker'

import './ColorPickerWrapper.scss'

interface IProps {
  value: string
  isAlwaysOpened?: boolean
  onChange(color: string): void
  colors?: string[]
  className?: string
  customColorPickerButton?: JSX.Element
  canAddNewColors?: boolean
  disabled?: boolean
}

@observer
export default class ColorPickerWrapper extends React.Component<IProps> {
  public static defaultProps = {
    colors: PRE_POPULATED_COLORS,
    className: '',
  }

  @observable private arePickerExpanded: boolean = false

  public constructor(props: IProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    const { value, className, customColorPickerButton, disabled } = this.props
    return (
      <div className={className}>
        <div className="color-picker">
          <Popover
            open={this.arePickerExpanded}
            onOpenChange={this.onOpenChange}
          >
            <PopoverTrigger
              disabled={disabled}
              nativeButton={false}
              render={<div className="inline-block" />}
            >
              {customColorPickerButton || (
                <div className={`color-picker-button`}>
                  <div
                    className="color-option"
                    style={{ backgroundColor: value }}
                  />
                  <ChevronRightIcon className="chevron-right mr10 tw:size-4" />
                </div>
              )}
            </PopoverTrigger>
            <PopoverContent
              side="left"
              className="tw:w-auto tw:bg-transparent tw:p-0 tw:shadow-none tw:ring-0"
            >
              {this.renderColorPickerSelector()}
            </PopoverContent>
          </Popover>
        </div>
      </div>
    )
  }

  private renderColorPickerSelector = () => {
    const { value, colors, isAlwaysOpened, canAddNewColors } = this.props
    const isExpanded = isAlwaysOpened || this.arePickerExpanded

    return (
      isExpanded && (
        <ColorPicker
          value={value}
          colors={colors}
          arePickerExpanded={this.arePickerExpanded}
          canAddNewColors={canAddNewColors}
          onChange={this.onColorClicked}
        />
      )
    )
  }

  @action.bound
  private onColorClicked(color: string) {
    this.props.onChange(color)

    this.collapseColorPicker()
  }

  @action.bound
  private onOpenChange(isOpen: boolean) {
    this.arePickerExpanded = isOpen
  }

  @action.bound
  private collapseColorPicker() {
    this.arePickerExpanded = false
  }
}
